export default "__VITE_ASSET__BzyD2cwI__"